import { h } from "@stencil/core";
/**
 * A generic button action.
 * @slot - The label for the action, applied to the button, or shown in a dropdown.
 */
export class ESActionGeneric {
    constructor() {
        this.dropdownItem = false;
        this.action = undefined;
        this.disabled = false;
        this.icon = undefined;
        this.dot = undefined;
    }
    render() {
        return (h("es-button", { key: 'e9adbd92276122c2d3bd25fc1dbed7c737919e98', onClick: this.action, variant: 'minimal', title: this.host.textContent ?? undefined, disabled: this.disabled }, h("es-badge", { key: '76a49e76ec424e756390610276aee3ed3d40a78f', slot: this.dropdownItem ? 'before' : undefined, variant: 'dot', color: this.dot, count: this.dot ? 1 : 0 }, h("es-icon", { key: '684f3a1d132345ae0d14cc72bbe08aa4fb8b281b', icon: this.icon, size: 20 })), this.dropdownItem && h("slot", { key: 'd538a71e78ae023b04e86c17d28bbb98d867488b' })));
    }
    static get is() { return "es-action"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["../action.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["../action.css"]
        };
    }
    static get properties() {
        return {
            "dropdownItem": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If the action is within an `es-action-dropdown`."
                },
                "attribute": "dropdown-item",
                "reflect": true,
                "defaultValue": "false"
            },
            "action": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "(e: MouseEvent) => any",
                    "resolved": "(e: MouseEvent) => any",
                    "references": {
                        "MouseEvent": {
                            "location": "global",
                            "id": "global::MouseEvent"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The action to take when the button is clicked."
                }
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If the action should be disabled."
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IconDescription",
                    "resolved": "[namespace: string | symbol, name: string] | string",
                    "references": {
                        "IconDescription": {
                            "location": "import",
                            "path": "../../es-icon/types",
                            "id": "src/components/es-icon/types.ts::IconDescription"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The icon to show for the action."
                },
                "attribute": "icon",
                "reflect": false
            },
            "dot": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "HTMLEsBadgeElement['color']",
                    "resolved": "\"error\" | \"okay\" | \"warning\" | undefined",
                    "references": {
                        "HTMLEsBadgeElement": {
                            "location": "global",
                            "id": "global::HTMLEsBadgeElement"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "If a dot should be shown on the action, to indicate attention being required."
                },
                "attribute": "dot",
                "reflect": false
            }
        };
    }
    static get elementRef() { return "host"; }
}
//# sourceMappingURL=es-action.js.map
